import { createEmitter } from "ts_utils";
import { TeamUpdateDTO } from "../data/dtos";
import { TeamDO } from "../data/TeamDO";
import { Services } from "../services/Services";
import { Templates } from "../ui/Templates";
import { teamMenuItem } from "../ui/templates/teamTemplates";

export class TeamListItem {
	public teamDO:TeamDO;
	
	public ui:HTMLDivElement;
	private _info:HTMLInputElement;
	private _sizeInput:HTMLInputElement;
	private _saveBtn:HTMLButtonElement;
	
	private _isDisposed:boolean = false;
	
	private _emitter = createEmitter<TeamLIEvent>();
	public get event() { return this._emitter.event; }
	
	constructor(teamDO:TeamDO){
		this.teamDO = teamDO;
		this._init();
	}
	
	public select():void {
		this.ui.classList.add("selected");
	}
	
	public deselect():void {
		this.ui.classList.remove("selected");
	}
	
	public prepareForRemoval():void {
		this._removeListeners();
		this._isDisposed = true;
	}
	
	private _init():void {
		this._draw();
		this._addListeners();
	}
	
	private _draw():void {
		this.ui = Templates.createDiv(teamMenuItem);
		this._info = this.ui.querySelector(".teamsdg-ti-info");
		this._sizeInput = this.ui.querySelector(".teamsdg-ti-sizeInput");
		this._saveBtn = this.ui.querySelector(".teamsdg-ti-saveBtn");
		
		this._info.innerHTML = `${this.teamDO.name} : ${this.teamDO.code}`;
		this._sizeInput.value = this.teamDO.size.toString();
	}
	
	private _onUiClick = (e:MouseEvent):void => {
		let ev = new TeamLIEvent();
		ev.type = TeamLIEventType.selectRequest;
		ev.target = this;
		this._emitter.emit(ev);
	}
	
	private _onSaveBtnClick = async (e:MouseEvent):Promise<void> => {
		this._removeListeners();
		let dto = new TeamUpdateDTO();
		dto.id = this.teamDO.id;
		dto.size = this._sizeInput.valueAsNumber;
		let rdto = await Services.updateTeam(dto);
		if (rdto.success){
			this.teamDO.updateFromDto(rdto.data);
		}
		else {
			this._sizeInput.value = this.teamDO.size.toString();
		}
		
		if (!this._isDisposed){
			this._addListeners();
		}
	}
	
	private _addListeners():void {
		this.ui.addEventListener("click", this._onUiClick);
		this._saveBtn.addEventListener("click", this._onSaveBtnClick);
	}
	
	private _removeListeners():void {
		this.ui.removeEventListener("click", this._onUiClick);
		this._saveBtn.removeEventListener("click", this._onSaveBtnClick);
	}
}

export class TeamLIEvent {
	public type:TeamLIEventType;
	public target:TeamListItem;
}

export enum TeamLIEventType {
	selectRequest
}